.jt{right:0.25rem;}